// extracted by mini-css-extract-plugin
module.exports = {"SettingsSection":"DialListSettings_SettingsSection__1hhCP","settingsTitle":"DialListSettings_settingsTitle__1dn11"};